import { combineReducers } from 'redux'
import accountReducer from './accountReducer'
import artistReducer from './artistReducer'
import assetReducer from './assetReducer'
import chatReducer from './chatReducer'
import creditsReducer from './creditsReducer'
import displayReducer from './displayReducer'
import fetchReducer from './fetchReducer'
import helpReducer from './helpReducer'
import harmonizeReducer from './harmonizeReducer'
import logReducer from './logReducer'
import messagesReducer from './messagesReducer'
import nftReducer from './nftReducer'
import playerControlsReducer from './playerControlsReducer'
import purchaseReducer from './purchaseReducer'
import reactorReducer from './reactorReducer'
import settingsReducer from './settingsReducer'
import songReducer from './songReducer'
import shortReducer from './shortReducer'

export default combineReducers({
  account: accountReducer,
  artist: artistReducer,
  asset: assetReducer,
  chat: chatReducer,
  credits: creditsReducer,
  display: displayReducer,
  fetch: fetchReducer,
  help: helpReducer,
  harmonize: harmonizeReducer,
  log: logReducer,
  messages: messagesReducer,
  nfts: nftReducer,
  playerControls: playerControlsReducer,
  purchase: purchaseReducer,
  reactor: reactorReducer,
  settings: settingsReducer,
  song: songReducer,
  short: shortReducer
})
